<!--
  ~ Copyright (C) 2019 - present by Potentially
  ~
  ~ Please see distribution for license.
  -->

<ptl-media-content-view
  [type]="content?.type"
  [position]="content?.position || 'CENTER'"
  [isExternalContent]="true"
  [canRemoveItem]="canRemoveItem"
  [newEditor]="newEditor"
  (removeMediaContent)="onCloseClick()"
  (mediaContentReplaced)="onReplaceMediaContent($event)"
  (regularLinkReplaced)="onReplaceRegularLink($event)"
  (updateMediaPosition)="onUpdateMediaPosition($event)"
>
  <div
    class="content-media__oembed content-media__oembed--disabled"
    [class.content-media__oembed--hidden]="!embedsAllowed()"
    #oembedEl
  ></div>
  @if (content?.html && !embedsAllowed()) {
    <ptl-embed-consent-placeholder [url]="content?.url" [siteName]="content?.siteName"></ptl-embed-consent-placeholder>
  }
  <div class="external-content-summary__caption-box">
    <p tabindex="0" class="caption-text">
      {{ content?.url }}
    </p>
  </div>
</ptl-media-content-view>
